import { api } from ".";

export const hrLogin = async (
  phone: string,
  password: string,
  companyCode: string
) => {
  try {
    const res = await api.post(`/login`, {
      password,
      phone,
      code: companyCode,
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const hrLogout = async (token: string) => {
  try {
    const res = await api.post(`/logout`, {
      token,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const hrAuthStatus = async (token: string) => {
  try {
    const res = await api.post(`/status`, {
      token,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const createHrUser = async ({ name, phone, privilege, password }: any) => {
  try {
    const res = await api.post(`/hr-user`, {
      name,
      phone,
      privilege,
      password,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getHrUsersList = async (params: Record<string, any>) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    const res = await api.get(`/hr-user/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const getHrUsersById = async ({ id }: any) => {
  try {
    const res = await api.get(`/hr-user?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteHrUserById = async ({ id }: any) => {
  try {
    const res = await api.delete(`/hr-user`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateHrUserById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`/hr-user`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getRoleList = async () => {
  try {
    const res = await api.get(`/hr-user/privileges`);
    return res;
  } catch (error) {
    return error;
  }
};
